import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useFavorites = (userToken, setShowAlert, setAlertText) => {
  const baseUrl = useBaseUrl();
  const [favorites, setFavorites] = useState([]);
  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/favorite`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        setFavorites(response.data.item_set);
        if (
          response.data.item_set.length === 0 &&
          setShowAlert &&
          setAlertText
        ) {
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
          setAlertText("موردی یافت نشد");
        }
      } catch (error) {
        console.log("Error during getting favorites", error);
        if (setShowAlert && setAlertText) {
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
          setAlertText("خطا در برقراری ارتباط");
        }
      }
    };
    if (userToken) {
      fetchFavorites();
    }
  }, [baseUrl, userToken]);
  return { favorites, setFavorites };
};

export default useFavorites;
